export const reorderInsuredItemsWithStatus = iI => {
  return iI.sort(compareStatus);
};

export const compareStatus = (a, b) => {
  if (a.status > b.status) return 1;
  if (a.status < b.status) return -1;
  return 0;
};
